define('OutSystems/ClientRuntime/ErrorScreen',["require", "exports", "./ErrorHandling", "./Exceptions", "./Logger", "./Navigation"], function (require, exports, ErrorHandling, Exceptions, Logger, Navigation) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initializeErrorPage = void 0;
    var DEFAULT_ERROR_MESSAGE = "There was an error processing your request.";
    var DEFAULT_EXTRA_ERROR_MESSAGE = "";
    var DEFAULT_RELOAD_BUTTON_LABEL = "RELOAD";
    var ERROR_MESSAGE_ID = "#error-screen-message-text";
    var ERROR_EXTRA_MESSAGE_ID = "#error-screen-message-text-extra";
    var RELOAD_BUTTON_ID = "#error-screen-message-reload-button";
    var SPINNER_ID = "#error-screen-spinner";
    var EXCEPTION_DETAIL_DIV = "#exception-detail";
    var TOGGLE_DETAIL_BUTTON_ID = "#error-screen-show-detail-button";
    var EXCEPTION_INFO_ID = "#error-screen-exception-message";
    var EXCEPTION_STACK_ID = "#error-screen-exception-stack";
    var EXCEPTION_DETAIL_TEXT_ID = "#exception-detail-text";
    function initializeErrorPage(appDefinition, runtime) {
        return Promise.resolve().then(function () {
            return runtime
                .initialize(appDefinition, 1)
                .then(function () {
                setErrorPageMessages(appDefinition.errorPageConfig);
                var errorMessageDetail = "";
                try {
                    var errorInfo = ErrorHandling.ErrorHandlingStorage.errorPageExceptionInfo.get();
                    if (errorInfo) {
                        errorMessageDetail = " " + errorInfo.message;
                    }
                }
                catch (ex) {
                }
                Logger.error("ErrorScreen", "[ErrorScreen]" + errorMessageDetail);
                if (!Logger.hadSessionLogs()) {
                    return runtime.initializeDatabase().then(function () {
                        Logger.flushLogsToServer();
                    });
                }
            })
                .catch(function (error) {
                console.error(error);
            });
        });
    }
    exports.initializeErrorPage = initializeErrorPage;
    function setErrorPageMessages(errorPageConfig) {
        var message = ErrorHandling.ErrorHandlingStorage.errorPageMessage.get();
        var extraMessage = ErrorHandling.ErrorHandlingStorage.errorPageExtraMessage.get();
        var errorInfo = ErrorHandling.ErrorHandlingStorage.errorPageExceptionInfo.get();
        if (errorInfo) {
            var errorMessage = errorInfo.message;
            var stack = Exceptions.getStack(errorInfo);
            if (stack) {
                errorMessage += "\n" + stack;
            }
            console.error(errorMessage);
            if (typeof document !== "undefined" && document.querySelector) {
                document.querySelector(EXCEPTION_INFO_ID).innerHTML = errorInfo.message;
                document.querySelector(EXCEPTION_STACK_ID).innerHTML = stack;
                document.querySelector(TOGGLE_DETAIL_BUTTON_ID).addEventListener("click", function () { return toggleExceptionInfo(); });
                if (errorPageConfig && errorPageConfig.showExceptionStack) {
                    var exceptionDetail = document.querySelector(EXCEPTION_DETAIL_DIV);
                    exceptionDetail.style.display = "block";
                }
            }
        }
        if (typeof document !== "undefined" && document.querySelector) {
            var customDefaultMessage = errorPageConfig && errorPageConfig.messages && errorPageConfig.messages.defaultMessage;
            var customExtraMessage = errorPageConfig && errorPageConfig.extraMessage;
            document.querySelector(ERROR_MESSAGE_ID).innerHTML = message || customDefaultMessage || DEFAULT_ERROR_MESSAGE;
            document.querySelector(ERROR_EXTRA_MESSAGE_ID).innerHTML =
                extraMessage || customExtraMessage || DEFAULT_EXTRA_ERROR_MESSAGE;
            document.querySelector(RELOAD_BUTTON_ID).innerHTML =
                (errorPageConfig && errorPageConfig.reloadLabel) || DEFAULT_RELOAD_BUTTON_LABEL;
            document.querySelector(RELOAD_BUTTON_ID).addEventListener("click", function () { return staticErrorPageRedirect(); });
        }
    }
    function staticErrorPageRedirect() {
        if (typeof document !== "undefined" && document.querySelector) {
            var buttonElement = document.querySelector(RELOAD_BUTTON_ID);
            buttonElement.style.display = "none";
            var spinnerElement = document.querySelector(SPINNER_ID);
            spinnerElement.style.display = "inline-block";
        }
        setTimeout(function () {
            Navigation.reloadApplication();
        }, 2000);
    }
    function toggleExceptionInfo() {
        if (typeof document !== "undefined" && document.querySelector) {
            var toggleDetail = document.querySelector(TOGGLE_DETAIL_BUTTON_ID);
            var exceptionDetail = document.querySelector(EXCEPTION_DETAIL_TEXT_ID);
            if (exceptionDetail.hidden) {
                toggleDetail.innerHTML = "Hide Detail";
                exceptionDetail.hidden = false;
            }
            else {
                toggleDetail.innerHTML = "Show Detail";
                exceptionDetail.hidden = true;
            }
        }
    }
});
//# sourceMappingURL=ErrorScreen.js.map;
